import {
  ALTENAR_ARRAY_PARAM_KEYS,
  ALTENAR_PAGE_BASE_ROUTE,
  ALTENAR_PAGE_BY_ROUT,
  ALTENAR_PAGE_PARAMS,
} from './altenarRoutesConstants';

const stripLeadingSlashes = (path = '') => path.replace(/^\/+/, '');

export const baseSegment = (path = '') => stripLeadingSlashes(path).split('/')[0].split('?')[0];

const toNumberOrRaw = raw => {
  if (raw === '' || raw === undefined || raw === null) return raw;
  const num = Number(raw);
  return Number.isFinite(num) ? num : raw;
};

const serializeParamValue = value => (Array.isArray(value) ? value.join(',') : String(value));

const collectIds = list =>
  Array.isArray(list) ? list.map(item => item?.id).filter(id => id != null) : undefined;

export const normalizeDetail = (detail = {}) => {
  if (!detail || typeof detail !== 'object') return detail;

  const sportId = detail.sportId ?? detail.sport?.id;
  const categoryIds = detail.categoryIds ?? collectIds(detail.categories);
  const championshipIds = detail.championshipIds ?? collectIds(detail.championships);
  const eventId = detail.eventId ?? detail.event?.id;

  return {
    ...detail,
    ...(sportId != null && { sportId }),
    ...(categoryIds?.length && { categoryIds }),
    ...(championshipIds?.length && { championshipIds }),
    ...(eventId != null && { eventId }),
  };
};

export const buildPathFromRoute = (rawDetail = {}) => {
  if (!rawDetail || typeof rawDetail !== 'object') return null;
  const detail = normalizeDetail(rawDetail);
  const { page } = detail;
  const base = ALTENAR_PAGE_BASE_ROUTE[page];
  if (!base) return null;

  const allowed = ALTENAR_PAGE_PARAMS[page] || [];
  const qsParts = [];

  if (page && page !== ALTENAR_PAGE_BY_ROUT[base]) {
    qsParts.push(`page=${encodeURIComponent(page)}`);
  }

  allowed.forEach(key => {
    const value = detail[key];
    if (value === undefined || value === null || value === '') return;
    qsParts.push(`${key}=${encodeURIComponent(serializeParamValue(value))}`);
  });

  return qsParts.length ? `/${base}?${qsParts.join('&')}` : `/${base}`;
};

export const parsePathToPageProps = (pathname = '', searchString = '') => {
  const segment = baseSegment(pathname);
  const fallbackPage = ALTENAR_PAGE_BY_ROUT[segment];
  if (!fallbackPage) return null;

  const search = new URLSearchParams((searchString || '').replace(/^\?/, ''));
  const explicitPage = search.get('page');
  const page = explicitPage || fallbackPage;
  const props = { page };
  const allowed = ALTENAR_PAGE_PARAMS[page] || [];

  allowed.forEach(key => {
    if (!search.has(key)) return;
    const raw = search.get(key);
    if (ALTENAR_ARRAY_PARAM_KEYS.includes(key)) {
      props[key] = raw.split(',').filter(Boolean).map(toNumberOrRaw);
    } else {
      props[key] = toNumberOrRaw(raw);
    }
  });

  return props;
};
